function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.471 24.8l12.36 3.23c.058.015.116.023.174.023.058 0 .116-.008.172-.022l12.361-3.23c.301-.078.51-.35.51-.66V6.705c0-.211-.098-.411-.265-.54-.074-.057-.158-.094-.246-.117l-12.36-3.233c-.113-.03-.232-.03-.346 0l-12.36 3.23c-.087.026-.171.063-.245.12-.168.129-.266.329-.266.54V24.14c0 .31.21.582.511.66zm.857-17.174l10.993 2.873v15.987L2.328 23.613V7.626zM25.68 23.613L14.69 26.486V10.463L25.68 7.591v16.022zM14.005 4.183l9.659 2.523-9.66 2.525-9.659-2.525 9.66-2.524z",
  transform: "translate(-409 -358) translate(385 342) translate(24 16)"
})))));

var SvgIconSiparis = function SvgIconSiparis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSiparis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-siparis.1b7b782f.svg";
export { ForwardRef as ReactComponent };